import {
  ButtonVariant,
  DateInput,
  FieldSet,
  Input,
  Select,
  Button,
  ButtonSize
} from "shared/components";
import { statuses } from "../constants";
import { FC } from "react";
import { BlankUnit } from "../types";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { useAuthContext } from "providers/Auth";
import { PropertyManagementSystem } from "shared/types/partner";

type Props = {
  unitForms: BlankUnit[];
  updateUnitForm: (index: number, field: string, value: string) => void;
  removeUnitForm: (index: number) => void;
};

export const UnitForms: FC<Props> = ({
  unitForms,
  updateUnitForm,
  removeUnitForm
}) => {
  const dictionary = useUnitsPropertiesDictionary();
  const { partner } = useAuthContext();
  const isMA =
    partner?.property_management_system?.name ===
    PropertyManagementSystem.ManageAmerica;

  return unitForms.map((unitForm, index) => {
    return (
      <FieldSet
        title={`${dictionary.Unit} ${index + 1}`}
        className="border-none"
        key={index + "_unitName"}
      >
        <div className="mb-4 flex gap-4">
          <div className="w-full">
            <Input
              id={`name-${index}`}
              label={`${dictionary.Unit} name`}
              placeholder={`${dictionary.Unit} name`}
              value={unitForm.unitName}
              onChange={(e) =>
                updateUnitForm(index, "unitName", e.target.value)
              }
              required
            />
          </div>
          <div className="w-full">
            <Input
              id={`external-id-${index}`}
              label={`${dictionary.Unit} ID`}
              placeholder={`${dictionary.Unit} ID`}
              value={unitForm.external_id}
              onChange={(e) =>
                updateUnitForm(index, "external_id", e.target.value)
              }
            />
          </div>
          {isMA ? (
            <>
              <div className="money-input-2 w-full">
                <Input
                  id={`homeRentAmount-${index}`}
                  label="Home rent"
                  placeholder="1,500"
                  value={unitForm.homeRentAmount}
                  type="money"
                  onChange={(e) =>
                    updateUnitForm(index, "homeRentAmount", e.target.value)
                  }
                  required
                />
              </div>
              <div className="money-input-2 w-full">
                <Input
                  id={`siteRentAmount-${index}`}
                  label="Site rent"
                  placeholder="1,500"
                  value={unitForm.siteRentAmount}
                  type="money"
                  onChange={(e) =>
                    updateUnitForm(index, "siteRentAmount", e.target.value)
                  }
                  required
                />
              </div>
            </>
          ) : (
            <div className="money-input-2 w-full">
              <Input
                id={`rentAmount-${index}`}
                label="Rent amount"
                placeholder="1,500"
                value={unitForm.rentAmount}
                type="money"
                onChange={(e) =>
                  updateUnitForm(index, "rentAmount", e.target.value)
                }
                required
              />
            </div>
          )}
        </div>
        <div className="mb-2 flex gap-4">
          <div className="w-full">
            <Select
              label="Current state"
              id={`occupied-${index}`}
              value={unitForm.occupied}
              options={statuses}
              searchable={false}
              hideOptional
              onChange={(e) => {
                updateUnitForm(index, "occupied", e.target.value);
                if (e.target.value) updateUnitForm(index, "available_at", "");
              }}
            />
          </div>
          <div className="w-full">
            <DateInput
              id="available_at"
              label="Available by date"
              value={unitForm.available_at}
              readOnly={!unitForm.occupied}
              hideOptional
              onChange={(e) => {
                updateUnitForm(index, "available_at", e.target.value);
              }}
            />
          </div>
        </div>

        {unitForms.length > 1 ? (
          <div className="flex justify-end">
            <Button
              variant={ButtonVariant.TEXT}
              size={ButtonSize.LG}
              className="ml-auto pr-0 text-primary-500 hover:text-primary-700"
              onClick={() => {
                removeUnitForm(index);
              }}
            >
              Remove
            </Button>
          </div>
        ) : null}
      </FieldSet>
    );
  });
};
